// SidebarPurchaseOrder component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import PageHeader from '../../../layout/page_header/page_header.jsx'
import IconButton from '../../../common/icon_button/icon_button.jsx'
import IconButtonIntro from '../../../../common/common/icon_button/icon_button.jsx'
import SidebarPurchaseItem from '../sidebar_purchaseorderitem/sidebar_purchaseorderitem.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import currency from '../../../../lib/currency.jsx'
import WysiwygEditor from '../../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'

class SidebarPurchaseOrder extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showIntroText: false
    }
  }

  static get propTypes () {
    return {
      purchaseOrder: PropTypes.object,
      downloadUrl: PropTypes.any,
      onClose: PropTypes.func,
      onSendEmail: PropTypes.func,
      onDownload: PropTypes.func,
      onEdit: PropTypes.func,
      onChangeItem: PropTypes.func,
      onBlurItem: PropTypes.func,
      onKeyDownItem: PropTypes.func,
      onDelete: PropTypes.func,
      onClickEditItem: PropTypes.func,
      onDeletePoItem: PropTypes.func,
      onChangeIntroText: PropTypes.func,
      onSaveIntroText: PropTypes.func,
      onChangeStatus: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      purchaseOrder: null,
      downloadUrl: null,
      onClose: null,
      onSendEmail: null,
      onDownload: null,
      onEdit: null,
      onChangeItem: null,
      onBlurItem: null,
      onKeyDownItem: null,
      onDelete: null,
      onClickEditItem: null,
      onDeletePoItem: null,
      onChangeIntroText: null,
      onSaveIntroText: null,
      onChangeStatus: null
    }
  }

  render () {
    return (
      <div className='sidebar-purchaseorder'>
        <div className='sidebaroverlay' />
        <div className='sidebarwrap'>
          {this._renderHeader()}
          {this._renderContent()}
        </div>
      </div>
    )
  }

  _renderHeader () {
    const { purchaseOrder, downloadUrl, onClose, onChangeStatus } = this.props

    const actions = [
      {
        ident: 'status',
        type: 'button',
        title: purchaseOrder.status,
        className: `headerstatus po_${purchaseOrder.status.toLowerCase()}`
      },
      {
        ident: 'mail',
        icon: 'mail',
        tooltipPosition: 'bottom',
        onClick: this._onSendMail.bind(this)
      },
      {
        ident: 'download',
        icon: 'download-solid',
        tooltipPosition: 'bottom',
        target: '_blank',
        href: downloadUrl
      },
      ...(purchaseOrder.status === 'Draft'
        ? [
          {
            ident: 'edit',
            icon: 'edit',
            tooltipPosition: 'bottom',
            onClick: this._onEdit.bind(this)
          }
        ]
        : [])
    ]

    const statInfos = [
      {
        title: 'invoicenum',
        value: purchaseOrder.invoiceNo
      },
      {
        title: 'project',
        value: purchaseOrder.project.title
      }
    ]

    const rightActions = [
      {
        icon: 'x',
        size: 'big',
        iconSize: '20',
        type: 'secondary',
        onClick: onClose
      }
    ]

    if (purchaseOrder.status === 'Draft') {
      rightActions.push({
        ident: 'unlike',
        icon: purchaseOrder.status === 'Draft' ? 'done' : '',
        tooltip:
          purchaseOrder.status === 'Draft' ? 'expense.list.tipMarkOpen' : '',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: 'success',
        className: 'statusupdate',
        onClick: onChangeStatus
      })
    } else {
      rightActions.push({
        ident: 'unlike',
        icon: purchaseOrder.status === 'Open' ? 'x' : 'reset',
        tooltip:
          purchaseOrder.status === 'Open'
            ? 'expense.list.actionMarkClosed'
            : 'expense.list.actionReopen',
        tooltipPosition: 'bottomright',
        size: 'big',
        iconSize: '20',
        type: purchaseOrder.status === 'Open' ? 'error' : 'success',
        className: 'statusupdate',
        onClick: onChangeStatus
      })
    }

    return (
      <PageHeader
        icon='expenses'
        title={purchaseOrder.contact.company}
        actions={actions}
        statInfos={statInfos}
        alignStatInfos='bottom'
        rightActions={rightActions}
      />
    )
  }

  _renderContent () {
    const {
      purchaseOrder,
      onChangeItem,
      onBlurItem,
      onKeyDownItem,
      onClickEditItem,
      onDeletePoItem
    } = this.props
    const { showIntroText } = this.state

    return (
      <div className='contentinfo'>
        {showIntroText && (
          <div className='editorcontent'>
            <div className='introtext'>
              <WysiwygEditor
                placeholder='projectBudget.sidebarActivity.labelIntro'
                value={purchaseOrder.introText}
                onChange={this._onChangeInput.bind(this, 'introText')}
                onBlur={this._onBlurInput.bind(this, 'introText')}
              />
            </div>
            <div className='actionclose'>
              <IconButtonIntro
                icon='common-item-delete'
                className='closeintro'
                title='projectBudget.sidebarActivity.labelRemoveIntro'
                canHover={false}
                size='small'
                onClick={this._onDeleteIntro.bind(this, 'introText')}
              />
            </div>
          </div>
        )}
        <div className='purchaseordercontent'>
          <div className='itemcontent'>
            <div className='items'>
              {purchaseOrder.items.map((item) => (
                <SidebarPurchaseItem
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  description={item.description}
                  total={item.total}
                  editable={item.editable}
                  canDragAndDrop={
                    !!(purchaseOrder &&
                    purchaseOrder.items &&
                    purchaseOrder.items.length > 1)
                  }
                  canEdit={purchaseOrder.status === 'Draft'}
                  onChange={onChangeItem}
                  onBlur={onBlurItem}
                  onKeyDown={onKeyDownItem}
                  onClickEdit={onClickEditItem}
                  onDeletePoItem={onDeletePoItem}
                />
              ))}
            </div>
            <div className='footer'>
              <div className='footertotal'>
                <div className='footercontent'>
                  <div className='label'>
                    <IntlMessage ident='projectBudget.sidebarActivity.labelTotal' />
                  </div>
                  <div className='total'>
                    {currency.formatSymbol(purchaseOrder.total)}
                  </div>
                </div>
              </div>
            </div>
            <div className='footeraction'>
              <IconButton
                icon='+'
                size='big'
                type='secondary'
                className='action'
                canHover
                onClick={this._onAddPurchaseOrder.bind(this, showIntroText)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onSendMail () {
    if (this.props.onSendEmail) {
      this.props.onSendEmail()
    }
  }

  _onDownload () {
    if (this.props.onDownload) {
      this.props.onDownload()
    }
  }

  _onEdit () {
    if (this.props.onEdit) {
      this.props.onEdit()
    }
  }

  _onChangeInput = (name, value, ev) => {
    const { onChangeIntroText } = this.props

    if (onChangeIntroText) {
      onChangeIntroText(name, value, ev)
    }
  };

  _onBlurInput = (name, ev) => {
    const { onSaveIntroText } = this.props

    if (onSaveIntroText) {
      onSaveIntroText(name, ev)
    }
  };

  _onDeleteIntro = (name, ev) => {
    const { onDelete } = this.props

    if (onDelete) {
      onDelete(name, '', ev)
    }

    this.setState({ showIntroText: false })
  };

  _onAddPurchaseOrder (_showIntroText) {
    this.setState({ showIntroText: true })
  }

  _onSavePurchaseOrder () {}
}

export default SidebarPurchaseOrder
